export const GET_ASSET_CONDITION_REQUEST = "GET_ASSET_CONDITION_REQUEST";
export const GET_ASSET_CONDITION_SUCCESS = "GET_ASSET_CONDITION_SUCCESS";
export const GET_ASSET_CONDITION_FAILURE = "GET_ASSET_CONDITION_FAILURE";

export const ADD_ASSET_CONDITION_REQUEST = "ADD_ASSET_CONDITION_REQUEST";
export const ADD_ASSET_CONDITION_SUCCESS = "ADD_ASSET_CONDITION_SUCCESS";
export const ADD_ASSET_CONDITION_FAILURE = "ADD_ASSET_CONDITION_FAILURE";

export const EDIT_ASSET_CONDITION_BYID_REQUEST = "EDIT_ASSET_CONDITION_BYID_REQUEST";
export const EDIT_ASSET_CONDITION_BYID_SUCCESS = "EDIT_ASSET_CONDITION_BYID_SUCCESS";
export const EDIT_ASSET_CONDITION_BYID_FAILURE = "EDIT_ASSET_CONDITION_BYID_FAILURE";

export const DELETE_ASSET_CONDITION_BYID_REQUEST = "DELETE_ASSET_CONDITION_BYID_REQUEST";
export const DELETE_ASSET_CONDITION_BYID_SUCCESS = "DELETE_ASSET_CONDITION_BYID_SUCCESS";
export const DELETE_ASSET_CONDITION_BYID_FAILURE = "DELETE_ASSET_CONDITION_BYID_FAILURE";

export const GET_LIST_FOR_COMMON_FILTER_REQUEST = "GET_LIST_FOR_COMMON_FILTER_REQUEST"
export const GET_LIST_FOR_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_COMMON_FILTER_SUCCESS"
export const GET_LIST_FOR_COMMON_FILTER_FAILURE = "GET_LIST_FOR_COMMON_FILTER_FAILURE"

export const GET_ASSET_CONDITION_BY_ID_REQUEST = "GET_ASSET_CONDITION_BY_ID_REQUEST"
export const GET_ASSET_CONDITION_BY_ID_SUCCESS = "GET_ASSET_CONDITION_BY_ID_SUCCESS"
export const GET_ASSET_CONDITION_BY_ID_FAILURE = "GET_ASSET_CONDITION_BY_ID_FAILURE"

export const EXPORT_ASSET_CONDITION_TABLE_REQUEST = "EXPORT_ASSET_CONDITION_TABLE_REQUEST"
export const EXPORT_ASSET_CONDITION_TABLE_SUCCESS = "EXPORT_ASSET_CONDITION_TABLE_SUCCESS"
export const EXPORT_ASSET_CONDITION_TABLE_FAILURE = "EXPORT_ASSET_CONDITION_TABLE_FAILURE"

export const GET_ALL_ASSET_CONDITION_LOG_REQUEST = "GET_ALL_ASSET_CONDITION_LOG_REQUEST";
export const GET_ALL_ASSET_CONDITION_LOG_SUCCESS = "GET_ALL_ASSET_CONDITION_LOG_SUCCESS";
export const GET_ALL_ASSET_CONDITION_LOG_FAILURE = "GET_ALL_ASSET_CONDITION_LOG_FAILURE";

export const RESTORE_ASSET_CONDITION_LOG_REQUEST = "RESTORE_ASSET_CONDITION_LOG_REQUEST";
export const RESTORE_ASSET_CONDITION_LOG_SUCCESS = "RESTORE_ASSET_CONDITION_LOG_SUCCESS";
export const RESTORE_ASSET_CONDITION_LOG_FAILURE = "RESTORE_ASSET_CONDITION_LOG_FAILURE";

export const DELETE_ASSET_CONDITION_LOG_REQUEST = "DELETE_ASSET_CONDITION_LOG_REQUEST";
export const DELETE_ASSET_CONDITION_LOG_SUCCESS = "DELETE_ASSET_CONDITION_LOG_SUCCESS";
export const DELETE_ASSET_CONDITION_LOG_FAILURE = "DELETE_ASSET_CONDITION_LOG_FAILURE";

export const UPDATE_ASSET_CONDITION_ENTITY_PARAMS_SUCCESS ="UPDATE_ASSET_CONDITION_ENTITY_PARAMS_SUCCESS";
export const UPDATE_ASSET_CONDITION_ENTITY_PARAMS_FAILURE ="UPDATE_ASSET_CONDITION_ENTITY_PARAMS_FAILURE";

